import { createSlice } from '@reduxjs/toolkit'
import { getPageFilter, saveFilters } from "../../utils/index";

const initialState = {
  announcementList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: getPageFilter('announcementList'),
  },
  announcementDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
}

export const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    getAnnouncementList: (state, action) => {
      state.announcementList.requesting = true
      state.announcementList.error = null
      state.announcementList.items = []
      state.announcementList.success = false
      state.announcementList.filters = action.payload
      saveFilters('announcementList', action.payload)
    },
    getAnnouncementListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.announcementList.requesting = false
      state.announcementList.items = data
      state.announcementList.success = true
      state.announcementList.pagination.current_page = current_page
      state.announcementList.pagination.per_page = per_page
      state.announcementList.pagination.total = total
    },
    getAnnouncementListFail: (state, action) => {
      state.announcementList.requesting = false
      state.announcementList.error = action.payload
    },
    getAnnouncementDetails: (state) => {
      state.announcementDetails.requesting = true
      state.announcementDetails.error = null
      state.announcementDetails.data = null
      state.announcementDetails.success = false
    },
    getAnnouncementDetailsSuccess: (state, action) => {
      state.announcementDetails.requesting = false
      state.announcementDetails.data = action.payload
      state.announcementDetails.success = true
    },
    getAnnouncementDetailsFail: (state, action) => {
      state.announcementDetails.requesting = false
      state.announcementDetails.error = action.payload
    },
    doAnnouncementCreate: (state) => {
      state.announcementDetails.requesting = true
      state.announcementDetails.error = null
      state.announcementDetails.data = null
      state.announcementDetails.success = false
    },
    doAnnouncementCreateSuccess: (state, action) => {
      state.announcementDetails.requesting = false;
      state.announcementDetails.data = action.payload;
      state.announcementDetails.success = true;
    },
    doAnnouncementCreateFail: (state, action) => {
      state.announcementDetails.requesting = false;
      state.announcementDetails.error = action.payload;
      state.announcementDetails.success = false;
    },
    doAnnouncementUpdate: (state) => {
      state.announcementDetails.requesting = true
      state.announcementDetails.error = null
      state.announcementDetails.data = null
      state.announcementDetails.success = false
    },
     doAnnouncementUpdateSuccess: (state, action) => {
      state.announcementDetails.requesting = false;
      state.announcementDetails.data = action.payload;
      state.announcementDetails.success = true;
    },
    doAnnouncementUpdateFail: (state, action) => {
      state.announcementDetails.requesting = false;
      state.announcementDetails.error = action.payload;
      state.announcementDetails.success = false;
    },
    doAnnouncementDelete: (state) => {
      state.announcementDetails.requesting = true
      state.announcementDetails.error = null
      state.announcementDetails.data = null
      state.announcementDetails.success = false
    },
    doAnnouncementReset: (state) => {
      state.announcementDetails.data = null
    },
    getDashboardAnnouncementList: (state, action) => {
      state.dashboardAnnouncementList.requesting = true
      state.dashboardAnnouncementList.error = null
      state.dashboardAnnouncementList.items = []
      state.dashboardAnnouncementList.success = false
      state.dashboardAnnouncementList.filters = action.payload
      saveFilters('dashboardAnnouncementList', action.payload)
    },
    getDashboardAnnouncementListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.dashboardAnnouncementList.requesting = false
      state.dashboardAnnouncementList.items = data
      state.dashboardAnnouncementList.success = true
      state.dashboardAnnouncementList.pagination.current_page = current_page
      state.dashboardAnnouncementList.pagination.per_page = per_page
      state.dashboardAnnouncementList.pagination.total = total
    },
    getDashboardAnnouncementListFail: (state, action) => {
      state.dashboardAnnouncementList.requesting = false
      state.dashboardAnnouncementList.error = action.payload
    },
  },
})

export const {
  getAnnouncementList,
  getAnnouncementListSuccess, doAnnouncementCreateSuccess,
  getAnnouncementListFail, doAnnouncementCreateFail,
  getAnnouncementDetails, getAnnouncementDetailsSuccess,
  getAnnouncementDetailsFail, doAnnouncementCreate,
  doAnnouncementUpdateSuccess, doAnnouncementUpdateFail,
  doAnnouncementUpdate, doAnnouncementDelete,
  doAnnouncementReset,
  getDashboardAnnouncementList,

} = announcementSlice.actions

export default announcementSlice.reducer
